import { Loader2Icon } from 'lucide-react'
import { motion } from 'motion/react'
import { useState } from 'react'

import { Button, Textarea, useFocusTransition } from 'slab'

interface OpenEndedProps {
  buttonText: React.ReactNode;
  name: string;
  onSubmit?: (value: string) => Promise<void> | void;
  placeholder: string;
}

export function OpenEnded ({
  buttonText,
  name,
  onSubmit,
  placeholder,
}: OpenEndedProps) {
  const [submitting, setSubmitting] = useState(false)

  useFocusTransition()

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <form
        className='flex flex-col gap-3'
        onSubmit={async (event) => {
          event.preventDefault()

          setSubmitting(true)

          try {
            const data = new FormData(event.target as HTMLFormElement)
            await onSubmit?.(data.get(name) as string)
          } finally {
            setSubmitting(false)
          }
        }}
      >
        <Textarea
          aria-label={placeholder}
          name={name}
          placeholder={placeholder}
          rows={4}
        />
        <Button
          disabled={submitting}
          variant='primary'
          width='full'
          type='submit'
        >
          {submitting ? <Loader2Icon className='animate-spin' /> : buttonText}
        </Button>
      </form>
    </motion.div>
  )
}

OpenEnded.displayName = 'InProductFeedback.OpenEnded'
